import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'common/components/Intl';

import store from '../store';

export default class WrappedBase extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <IntlProvider locale="en">{this.props.children}</IntlProvider>
      </Provider>
    );
  }
}
